import React, { useState } from "react";
import {
  Box,
  FormControl,
  Grid,
  TextField,
  Stack,
  Button,
  Typography,
  TableContainer,
  Paper,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Backdrop,
  CircularProgress,
  Badge,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";
import SendIcon from "@mui/icons-material/Send";
import PreviewModalContent from "./PreviewModalContent";
import { GetChatGPTResponses } from "../../../utilities/chatgptconn";
import ChatComponent from "./ChatComponent";
import axiosBaseURL from "../../../utilities/httpCommon";
import OfficeAddinMessageBar from "./OfficeAddinMessageBar";

/* global console */
const Chatgptai = () => {
  const [paragraphs, setParagraphs] = useState(5);
  const [tabvalue, settabValue] = useState("1");
  const [searchtext, setsearchtext] = useState("");
  const [paragraphlist, setparagraphlist] = useState([]);
  const [value, setValue] = React.useState([]);
  const [opendlg, setOpendlg] = React.useState(false);
  const [isloading, setisloading] = useState(false);
  const [selecteditem, setselecteditem] = useState();
  const [errMsgd, seterrMsgd] = useState("");

  const errorDismissed = () => {
    seterrMsgd("");
  };

  const handleClosedlg = async (newValue?: any) => {
    setOpendlg(false);
    setValue(newValue);
    console.log("whatvalue");
    console.log(newValue);
    console.log("whatvalue-1");
    console.log(paragraphlist);
    const newState = [...paragraphlist];
    newState[newValue.id].content = newValue.generated;
    newState[newValue.id].altlist = newValue.alternate;
    newState[newValue.id].summary = newValue.sumarizetext;
    newState[newValue.id].summarycaption = newValue.gsumcaption;
    newState[newValue.id].altcaptions = newValue.gcaptions;
    setparagraphlist(newState);
    console.log(paragraphlist);
  };
  async function OpenDialogforContent(selitem) {
    setOpendlg(true);
    setselecteditem(selitem);
  }
  function GetRunCount(bgitem) {
    if (bgitem != null) {
      if (bgitem.content.length > 0) {
        return bgitem.content.length;
      }
    }
    return 0;
  }
  async function GetHeadingfromChatAI() {
    //Check for validation
    setisloading(true);
    const resauth = await axiosBaseURL
      .get("/sfserver/auth/validate", {
        withCredentials: true,
      })
      .catch((error: any) => {
        setisloading(false);
        if (error.response) {
          console.log(error.response);
          seterrMsgd(error.response.data);
        } else if (error.request) {
          seterrMsgd(error.request);
        } else {
          seterrMsgd(error.message);
        }
        return null;
      });
    setisloading(false);
    if (resauth === null) {
      return;
    }
    //Ends here

    setisloading(true);
    const response = await GetChatGPTResponses(paragraphs, searchtext);
    setisloading(false);
    if (Array.isArray(response.data?.choices) && response.data.choices.length && response.data.choices[0].message) {
      const paragraphArr = response.data.choices[response.data.choices.length - 1].message.content?.split("\n");
      let paras = [];
      paragraphArr.map((element, index) => {
        let paracontent = [];
        paracontent.push(element);
        paras.push({
          id: index,
          heading: element,
          content: [],
          hinttext: searchtext,
          altlist: [],
          summary: "",
          summarycaption: "",
          altcaptions: [],
        });
      });
      setparagraphlist(paras);
    }
    return response;
  }
  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    settabValue(newValue);
  };
  function handleIncrement() {
    setParagraphs(function (prevCount) {
      return (prevCount += 1);
    });
  }
  function handleDecrement() {
    setParagraphs(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 0);
      }
    });
  }
  // useEffect(() => {
  //   setsearchtext("non disclosure agreement");
  // }, []);
  return (
    <Box sx={{ p: 1, marginTop: 0 }}>
      <TabContext value={tabvalue}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", padding: 0, margin: 0 }}>
          <TabList onChange={handleTabChange} aria-label="Properties" variant="fullWidth" sx={{ padding: 0 }}>
            <Tab label="Interactive AI" value="1" sx={{ fontFamily: "Arial", fontWeight: "bold", padding: 0 }} />
            <Tab label="Generative AI" value="2" sx={{ fontFamily: "Arial", fontWeight: "bold", padding: 0 }} />
          </TabList>
        </Box>
        <TabPanel value="1" sx={{ padding: 0 }}>
          <TableContainer component={Paper}>
            <ChatComponent />
          </TableContainer>
        </TabPanel>
        <TabPanel value="2" sx={{ padding: 0 }}>
          <TableContainer sx={{ paddin: 0, margin: 0 }}>
            <Grid container>
              {errMsgd.length > 0 ? <OfficeAddinMessageBar onDismiss={errorDismissed} message={errMsgd + " "} /> : null}
              <Grid item xs={12}>
                <FormControl fullWidth size="small" sx={{ marginTop: 2 }}>
                  <TextField
                    variant="outlined"
                    value={searchtext}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setsearchtext(event.target.value);
                    }}
                    sx={{ padding: 0, margin: 0 }}
                    label="Document type"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Stack direction="row" spacing={1} sx={{ marginTop: 2 }}>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ width: "28px", bgcolor: "#1C39BB", height: "28px" }}
                    onClick={GetHeadingfromChatAI}
                  >
                    <Typography sx={{ color: "white" }}>Draft</Typography>
                  </Button>
                  <Typography>Paragraphs:</Typography>
                  <IconButton onClick={handleIncrement} size="small">
                    <AddCircleRoundedIcon fontSize="small" color="primary" />
                  </IconButton>
                  <TextField
                    variant="outlined"
                    size="small"
                    value={paragraphs}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setParagraphs(parseInt(event.target.value));
                    }}
                    inputProps={{
                      style: {
                        padding: 1,
                        borderColor: "#1C39BB",
                        marginTop: 0,
                        width: "100%",
                        textAlign: "center",
                        alignContent: "center",
                      },
                    }}
                  >
                    {paragraphs}
                  </TextField>
                  <IconButton onClick={handleDecrement} size="small">
                    <RemoveCircleRoundedIcon fontSize="small" color="primary" />
                  </IconButton>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <List
                  dense
                  sx={{
                    width: "100%",
                    position: "relative",
                    overflow: "auto",
                    marginBottom: 2,
                    marginTop: 2,
                  }}
                >
                  {paragraphlist.map((item, index) => (
                    <ListItem
                      sx={{ margin: "0 px", padding: "0 px" }}
                      divider
                      disablePadding={true}
                      key={index}
                      secondaryAction={
                        <Badge color="secondary" badgeContent={GetRunCount(item)}>
                          <IconButton edge="end" aria-label="delete" onClick={() => OpenDialogforContent(item)}>
                            <SendIcon sx={{ width: 19, height: 19 }} />
                          </IconButton>
                        </Badge>
                      }
                    >
                      <ListItemText
                        style={{ maxWidth: "250px", wordBreak: "break-word" }}
                        primary={
                          <Typography
                            sx={{
                              display: "inline",
                              fontSize: 14,
                            }}
                            component="span"
                            variant="caption"
                            color="#1C39BB"
                          >
                            {item.heading}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Grid>
            </Grid>
          </TableContainer>
        </TabPanel>
      </TabContext>
      <PreviewModalContent
        keepMounted
        processitem={selecteditem}
        headings={paragraphlist}
        dlgparalist={paragraphlist}
        open={opendlg}
        onClose={handleClosedlg}
        value={value}
      />
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};
export default Chatgptai;
